import { render, staticRenderFns } from "./widgetIpsecDisconnTunnel.vue?vue&type=template&id=278ec9ba&scoped=true&"
import script from "./widgetIpsecDisconnTunnel.vue?vue&type=script&lang=js&"
export * from "./widgetIpsecDisconnTunnel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278ec9ba",
  null
  
)

export default component.exports